import { FC } from 'react';

import { BannerModerationState, getBannerTextTypography } from 'utils/banner/utils';
import { BannerModerationStatus } from 'utils/constants/banner';
import { CampaignType } from 'utils/constants/campaign';
import { DOT } from 'utils/constants/common';

import { Box, Card, Flex, Text, useBreakpoint } from '@hh.ru/magritte-ui';

import { BannerImages } from 'components/Banners/components/Banner/components/BannerInfo/components/BannerImages/BannerImages';
import { BannerStatus } from 'components/Banners/components/Banner/components/BannerInfo/components/BannerStatus/BannerStatus';

import { CampaignFrontendStatus } from 'store/models/campaignsDashboard';

interface BannerInfoProps {
    title: string;
    text: string;
    url: string;
    imageUrl: string;
    videoThumbnailUrl: string;
    enabled: boolean;
    moderationStatus: BannerModerationStatus;
    states: BannerModerationState[];
    campaignStatus: CampaignFrontendStatus;
    advertisingServiceType: CampaignType;
}

export const BannerInfo: FC<BannerInfoProps> = ({
    imageUrl,
    videoThumbnailUrl,
    text,
    title,
    enabled,
    moderationStatus,
    states,
    url,
    campaignStatus,
    advertisingServiceType,
}) => {
    const { isMobile } = useBreakpoint();

    const isCampaignArchived = campaignStatus === CampaignFrontendStatus.Archived;

    const images = <BannerImages imageUrl={imageUrl} videoThumbnailUrl={videoThumbnailUrl} />;

    return (
        <Card.Segment
            p={isMobile ? 16 : 24}
            gap={isMobile ? 16 : 24}
            direction="row"
            justify={isMobile ? 'space-between' : 'start'}
        >
            {!isMobile && images}
            <Flex align="start" justify={isMobile ? 'start' : 'space-between'} gap={8} direction="column" minWidth={0}>
                <Flex direction="column" gap={isMobile ? 4 : 8}>
                    <Text typography={isMobile ? 'subtitle-1-semibold' : 'title-5-semibold'}>{title}</Text>
                    <Text typography={getBannerTextTypography(isMobile)} style="secondary">
                        {text}
                    </Text>
                </Flex>
                <Flex direction={isMobile ? 'column' : 'row'} gap={isMobile ? 4 : 8} minWidth={0} width="100%">
                    {!isCampaignArchived && (
                        <BannerStatus
                            enabled={enabled}
                            moderationStatus={moderationStatus}
                            states={states}
                            campaignStatus={campaignStatus}
                        />
                    )}
                    {advertisingServiceType !== CampaignType.Information && (
                        <>
                            {!isMobile && !isCampaignArchived && (
                                <Text typography="label-3-regular" style="secondary">
                                    {DOT}
                                </Text>
                            )}
                            <Box grow={1} minWidth={0}>
                                <Text typography="label-3-regular" style="secondary" ellipsis>
                                    {url}
                                </Text>
                            </Box>
                        </>
                    )}
                </Flex>
            </Flex>
            {isMobile && images}
        </Card.Segment>
    );
};
